// @flow
import styled from 'styled-components';
import { Link } from "react-router-dom";

import colors from '../../assets/css/colors';

export const ButtonAlert = styled.button`
	outline: none;
	border: none;
	background: ${colors.red};
	border: 1px solid ${colors.red};
	color: white;
	border-radius: 3px;
	font-weight: bold;
	font-size: 12px;
	letter-spacing: 0.5px;
	line-height: 1.2;
	padding: 10px;
	cursor: pointer;
	width: ${({ width }) => width || 'auto'};

	&:disabled {
		background: ${colors.lightGreen};
		color: #fff;
		border-color: ${colors.lightGreen};
	}
`;

ButtonAlert.displayName = "ButtonAlert";

export const ButtonAlertLink = styled(ButtonAlert.withComponent(Link))`
	display: flex;
	align-items: center;
    justify-content: center;
	text-decoration: none;
`;

ButtonAlertLink.displayName = "ButtonAlertLink";

export default ButtonAlert;


// WEBPACK FOOTER //
// ./src/components/ButtonAlert/index.js